export enum SiteType {
    MOBILE= 1,              // Móvil
    STOP = 2,               // Parada
    PLACE = 3,              // Lugar
    EXTERNAL_PROVIDER = 4,  // Proveedor Externo
    VEHICLE = 5             // Vehículo
}